import { render } from "./DeleteMedicationClassDialog.vue?vue&type=template&id=06cffb06"
import script from "./DeleteMedicationClassDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMedicationClassDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__